var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/* tslint:disable */
import "./shared/polyfills/arrayIncludes";
import "./shared/polyfills/stringIncludes";
import "./shared/polyfills/promise";
import * as React from "react";
import { hydrate } from "react-dom";
import { setupGlobalComponents } from "./shared/globalComponents";
import Root from "./shared/root";
var initialState = JSON.parse(document.getElementById("initialState").textContent);
window.__initialState = initialState;
hydrate(React.createElement(Root, __assign({}, initialState)), document.getElementById("app"));
if (module.hot) {
    module.hot.accept("./shared/root", function () {
        var NewRoot = require("./shared/root").default;
        hydrate(React.createElement(NewRoot, __assign({}, window.__initialState)), document.getElementById("app"));
    });
}
if (!window.__initialState.useLegacyHeader) {
    setupGlobalComponents();
}
if (module.hot) {
    module.hot.accept("./shared/globalComponents", function () {
        var setup = require("./shared/globalComponents").setupGlobalComponents;
        setup();
    });
}



//////////////////
// WEBPACK FOOTER
// ./app/client.tsx
// module id = Df23
// module chunks = 2